import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          iShirts, Moda feminina. Disponível em breve!
        </p>
        <a
          className="App-link"
          href="https://ishirts.page.link/instagram"
          target="_blank"
          rel="noopener noreferrer"
          title="iShirts Instagram"
        >
          Saiba mais
        </a>
      </header>
    </div>
  );
}

export default App;
